var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row interment-entity-content" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("entity_id", { required: false }),
                      expression:
                        "rulesField('entity_id', { required: false })",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: `input-entity_id`,
                    name: `entity_id`,
                    noWrap: false,
                    initialData: _vm.form,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      { "is-invalid": _vm.fnHasError(`entity_id`, _vm.vScope) },
                    ],
                    error: _vm.fnFirstError(`entity_id`, _vm.vScope),
                    label: _vm.entityLabel,
                    ajaxOptions: {
                      url: _vm.url.lookup,
                      urlParams: { model: "entities", id: _vm.form.id },
                      shouldLoadDataOnDropdownOpen: true,
                    },
                    reduce: (onption) => onption[_vm.entityLabel],
                    allowCreate: true,
                    templateCreate: (label) =>
                      _vm.$t(`${_vm.modelTranslateID}.templateCreate`, {
                        label: label,
                      }),
                  },
                  on: {
                    selected: _vm.onSelectedEntity,
                    created: _vm.onCreated,
                  },
                  model: {
                    value: _vm.form[_vm.entityLabel],
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        _vm.entityLabel,
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form[entityLabel]",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("cemetery_id", { required: true }),
                      expression:
                        "rulesField('cemetery_id', { required: true })",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-entity_gender",
                    name: "entity_gender",
                    label: "name",
                    options: _vm.genders,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_gender",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_gender", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.gender_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "gender_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.gender_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.gender`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("religion_type_id"),
                      expression: "rulesField('religion_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-entity_religion",
                    name: "entity_religion",
                    label: "name",
                    options: _vm.religions,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_religion",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_religion", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.religion_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "religion_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.religion_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.religion`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDatePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-entity_birth_at",
                    name: "entity_birth_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_birth_at",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_birth_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.birth_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "birth_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.birth_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.birth_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDatePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("death_at", {
                        dateAfter: [
                          _vm.form.birth_at,
                          true,
                          _vm.$t(`${_vm.modelTranslateID}.birth_at`),
                        ],
                      }),
                      expression:
                        "rulesField('death_at', { dateAfter: [form.birth_at, true, $t(`${modelTranslateID}.birth_at`)] })",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-entity_death_at",
                    name: "entity_death_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_death_at",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_death_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.death_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "death_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.death_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.death_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-3" },
          [
            _c(
              "MaterialInput",
              {
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: true,
                  disabled: true,
                  id: "input-entity_age",
                  name: "entity_age",
                  value: _vm.age,
                  "data-vv-scope": _vm.vScope,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.modelTranslateID}.age`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-9" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("cause_death_type_id"),
                      expression: "rulesField('cause_death_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-entity_cause_death",
                    name: "entity_cause_death",
                    label: "name",
                    options: _vm.causes_death,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_cause_death",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_cause_death", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.cause_death_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "cause_death_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.cause_death_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.cause_death`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("entity_occupation"),
                      expression: "rulesField('entity_occupation')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-entity_occupation",
                    name: "entity_occupation",
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_occupation",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_occupation", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.occupation,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "occupation",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.occupation",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.occupation`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 address" }, [
          _c("h6", { staticClass: "header" }, [
            _vm._v(
              _vm._s(_vm.$t(`${_vm.translateID}.form.last_known_address`))
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-sm-12" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("entity_address", { min: 3 }),
                        expression: "rulesField('entity_address', { min: 3 })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-entity_address",
                      name: "entity_address",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_address",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_address", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "address",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.address",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.address`)) +
                        "\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-6" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("entity_locality"),
                        expression: "rulesField('entity_locality')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-entity_locality",
                      name: "entity_locality",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_locality",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_locality", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.locality,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "locality",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.locality",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.locality`)) +
                        "\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-6" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("entity_postal_code", {
                          min: 8,
                          max: 8,
                          regex: /^\d{4}-\d{3}$/,
                        }),
                        expression:
                          "rulesField('entity_postal_code', { min: 8, max: 8, regex: /^\\d{4}-\\d{3}$/ })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-entity_postal_code",
                      name: "entity_postal_code",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_postal_code",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_postal_code", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.postal_code,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "postal_code",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.postal_code",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.postal_code`)) +
                        "\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }